import { TableColumnSelectorComponent } from 'app/components/ui/table-column-selector'
import { useTableColumnSelector, type TableColumnSelectorProps } from './useTableColumnSelector'

export default function TableColumnSelector<T>(props: TableColumnSelectorProps<T>): React.ReactElement {
  const hook = useTableColumnSelector(props)
  return <TableColumnSelectorComponent {...hook} />
}
